import { MutationTree } from 'vuex'
import { Persons, CurrentPerson } from './types'
import { Person } from '@/helpers/objects'

const MAX_LENGTH_PATH = 100

export const mutations: MutationTree<Persons> = {
  setPersons(state, dataPerson) {
    const newPerson = new Person({
      id: dataPerson.id,
      created_by: dataPerson.created_by,
      uriId: dataPerson.uriId,
      first_name: dataPerson.first_name,
      last_name: dataPerson.last_name,
      fullName: dataPerson.fullName,
      phones: dataPerson.phones,
      account_id: dataPerson.account_id,
      roles: dataPerson.roles,
      emails: dataPerson.emails,
      profile: dataPerson.profile,
      identification_number: dataPerson?.identification_number,
      identification_type: dataPerson?.identification_type,
      ibutton: dataPerson?.ibutton
    })

    state.persons.push(newPerson)
    // Vue.set(state.things[dataThing.id], dataThing.id, newThing)
  },

  setThingsAssignments(state, { uriId, thingsAssignments }) {
    state.thingsAssignments[uriId] = thingsAssignments
  },

  setCurrentPerson(state, payload) {
    state.currentPerson = payload
  },

  cleanPersonsState(state) {
    state.persons = []
  },
  setResponseError(state, payload) {
    state.responseError = payload
  },

  setResponseMessage(state, message) {
    state.responseMessage = message
  },
  resetPersonsState(state) {
    state.persons = []
    state.responseMessage = ''
    state.responseError = false
  },
  updatePerson(
    state,
    { uriId, firstName, lastName, identifyType, identifyNumber, phonesIn, ibutton }
  ) {
    for (let i = 0; i < state.persons.length; i++) {
      if (state.persons[i].uriId === uriId) {
        state.persons[i].first_name = firstName
        state.persons[i].last_name = lastName
        state.persons[i].identification_type = identifyType
        state.persons[i].identification_number = identifyNumber
        state.persons[i].phones = JSON.parse(JSON.stringify(phonesIn))
        state.persons[i].ibutton = ibutton
      }
    }
    const currentPerson = state.currentPerson as CurrentPerson
    currentPerson.first_name = firstName
    currentPerson.last_name = lastName
    currentPerson.fullName = `${firstName} ${lastName}`
    currentPerson.identification_type = identifyType
    currentPerson.identification_number = identifyNumber
    currentPerson.phones = JSON.parse(JSON.stringify(phonesIn))
    currentPerson.ibutton = ibutton
    Object.assign(state.currentPerson, currentPerson)
  },
  updatePersonRol(state, { roles, profile, phones, ibutton }) {
    const currentPerson = state.currentPerson as CurrentPerson
    currentPerson.roles = JSON.parse(JSON.stringify(roles))
    currentPerson.profile = profile
    currentPerson.phones = JSON.parse(JSON.stringify(phones))
    currentPerson.ibutton = ibutton
    Object.assign(state.currentPerson, currentPerson)
  },
  resetFilterPersonsState(state) {
    state.filterPersons = state.persons
  },
  setFilterPersonsByString(state, { filterPersons }) {
    state.filterPersons = filterPersons
  }
}
